<div class="vh-100">
  <!-- Top Bar -->
  <div
    class="w-100 fixed-top-bar global__top-bar__height d-flex align-items-center justify-content-between fs-18px font-weight-bold px-15px border-bottom border-color-grey"
  >
    <div class="d-flex align-items-center">
      <top-bar-mobile-navigation-control
        class="mr-15px d-lg-none d-inline-block"
      ></top-bar-mobile-navigation-control>
      Buy $DESO
    </div>

    <top-bar-mobile-log-in-or-sign-up></top-bar-mobile-log-in-or-sign-up>
  </div>

  <div class="global__mobile-scrollable-section">
    <div class="global__top-bar__height"></div>
    <!-- Description, Logged Out -->
    <div class="fc-default fs-15px mt-30px pr-15px ml-15px pb-30px">
      $DESO is a cryptocurrency like Bitcoin, only it powers the first
      decentralized social network.
    </div>

    <!-- Spacer -->
    <div style="height: 10px"></div>

    <!-- Logged Out Info -->
    <div class="w-100 border-top border-color-grey">
      <div
        class="fs-18px fc-default font-weight-bold ml-15px buy-deso__box-label-adjustment"
        style="background-color: white"
      >
        How do I get $DESO?
      </div>
      <div>
        <div class="d-flex w-100 mt-5px pl-15px fs-15px pb-15px pr-30px">
          <div style="min-width: 120px">
            <a (click)="globalVars.launchSignupFlow()" class="--link"
              >Create an anonymous account</a
            >
            to buy $DESO in under a minute.
          </div>
        </div>
      </div>
    </div>

    <!-- Spacer -->
    <div style="height: 20px"></div>

    <div class="w-100 border-top border-color-grey">
      <div
        class="fs-18px mb-10px fc-default font-weight-bold ml-15px buy-deso__box-label-adjustment"
        style="background-color: white"
      >
        What is $DESO useful for?
      </div>
      <div>
        <div
          class="d-flex w-100 pl-15px pt-15px pb-15px fs-15px buy-deso__amount-background"
        >
          <div style="min-width: 120px">
            You can use it to buy and sell
            <a
              [routerLink]="['/' + globalVars.RouteNames.CREATORS]"
              [routerLinkActive]="['selected']"
              [routerLinkActiveOptions]="{ exact: true }"
              queryParamsHandling="merge"
            >
              creator coins
            </a>
          </div>
        </div>
        <div
          class="d-flex w-100 justify-content-between pl-15px pr-15px pb-15px mt-15px fs-15px fc-default"
        >
          You can use it to send messages to people
        </div>
        <div
          class="d-flex w-100 justify-content-between buy-deso__amount-background pl-15px pr-15px pt-15px pb-15px mb-15px fs-15px fc-default"
        >
          <div>
            You can use it to
            <a
              [routerLink]="['/' + globalVars.RouteNames.BROWSE]"
              [routerLinkActive]="['selected']"
              [routerLinkActiveOptions]="{ exact: true }"
              queryParamsHandling="merge"
            >
              submit posts
            </a>
            of your own
          </div>
        </div>
        <div
          class="d-flex w-100 justify-content-between pl-15px pr-15px pb-15px fs-15px fc-default"
        >
          You can buy it anonymously with Bitcoin in under a minute
        </div>
        <div
          class="d-flex w-100 justify-content-between buy-deso__amount-background pl-15px pr-15px pt-15px pb-15px fs-15px fc-default"
        >
          <div>It's blockchain's "iPhone moment."</div>
        </div>
      </div>
    </div>

    <!-- SPACER FOR BOTTOM BAR ON MOBILE -->
    <div class="global__bottom-bar-mobile-height"></div>
    <div class="global__bottom-bar-mobile-height"></div>
  </div>
</div>
